import { useState } from 'react'

export const useConfirm = () => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const handleConfirmOpen = () => {
    setIsConfirmOpen(true)
  }
  const handleConfirmClose = () => {
    setIsConfirmOpen(false)
  }
  return {
    isConfirmOpen,
    handleConfirmOpen,
    handleConfirmClose
  }
}
